module.exports = __webpack_public_path__ + "img/img2.1ca98b09.png";